import getInstanceAxios from "../request"
function instanceAxios(token) {
  return getInstanceAxios(token)
}

export default instanceAxios
